var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import WixComponent from '../BaseComponents/WixComponent';
import styles from './PopoverMenu.scss';
import Tooltip from '../Tooltip';
import Button from '../Backoffice/Button';
import Dots from '../Icons/dist/components/Dots';
import PopoverMenuItem from '../PopoverMenuItem';

var PopoverMenu = function (_WixComponent) {
  _inherits(PopoverMenu, _WixComponent);

  function PopoverMenu() {
    _classCallCheck(this, PopoverMenu);

    return _possibleConstructorReturn(this, (PopoverMenu.__proto__ || Object.getPrototypeOf(PopoverMenu)).apply(this, arguments));
  }

  _createClass(PopoverMenu, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var menuItems = React.Children.map(this.props.children, function (child, i) {
        var _child$props = child.props,
            onClick = _child$props.onClick,
            passThroughProps = _objectWithoutProperties(_child$props, ['onClick']);

        var onClickWithHide = function onClickWithHide() {
          _this2.tooltip.hide();
          onClick();
        };
        return React.createElement(PopoverMenuItem, _extends({}, passThroughProps, { onClick: onClickWithHide, key: i }));
      });

      var tooltipContent = React.createElement(
        'ul',
        { className: styles.menu },
        menuItems
      );

      return React.createElement(
        Tooltip,
        {
          ref: function ref(tooltip) {
            _this2.tooltip = tooltip;
          },
          placement: this.props.placement,
          alignment: 'center',
          content: tooltipContent,
          showTrigger: 'click',
          hideDelay: 0,
          hideTrigger: 'click',
          theme: 'light',
          size: this.props.size,
          maxWidth: this.props.maxWidth,
          shouldCloseOnClickOutside: true
        },
        React.createElement(
          Button,
          {
            type: 'button',
            height: 'medium',
            theme: this.props.buttonTheme
          },
          React.createElement(Dots, { size: '12px' })
        )
      );
    }
  }]);

  return PopoverMenu;
}(WixComponent);

PopoverMenu.propTypes = {
  size: Tooltip.propTypes.size,
  placement: Tooltip.propTypes.placement,
  buttonTheme: Button.propTypes.theme,
  maxWidth: Tooltip.propTypes.maxWidth
};
PopoverMenu.defaultProps = {
  size: 'normal',
  placement: 'top',
  buttonTheme: 'icon-greybackground',
  maxWidth: '378px'
};


export default PopoverMenu;
//# sourceMappingURL=PopoverMenu.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/PopoverMenu/PopoverMenu.js